<template>
  <div>
    <b-overlay :show="loading">
      <b-container fluid>
        <span 
          v-if="zaprosInfo"
          @click="visible = 'zapros'"
          :class="visible === 'zapros' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Запрос на котировку</span>
        <span 
          v-if="obshayaInfo"
          @click="visible = 'obshaya'"
          :class="visible === 'obshaya' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Общая информация</span>
        <span 
          v-if="etapyDvigeniya"
          @click="visible = 'etapy'"
          :class="visible === 'etapy' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Этапы движения</span>
        <span 
          v-if="timelinePostavki"
          @click="visible = 'graph'"
          :class="visible === 'graph' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Таймлайн поставки</span>
      </b-container>

      <div v-show="visible === 'zapros'">
        <b-card>
          <b-container fluid>
            <template v-if="detailedItem.quotation && detailedItem.quotation.data">
                <OrderServiceDeliveryQuotationInfo 
                    :quotation="detailedItem.quotation"
                    :showAnswers="true"
                />
            </template>
            <template v-else>
                <div style="font-style: italic; padding: 25px 15px">Запрос на котировку не составлялся.</div>
            </template>
          </b-container>
        </b-card>
      </div>

      <div v-show="visible === 'obshaya'">
        <b-card>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="6" md="2">
                    <label for="nomer_of_dogovor">Номер договора:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <b-form-input v-model="editedData['0'].value" size="sm" placeholder="" :disabled="true"></b-form-input>
                    <template v-if="editMode && filteredDocs.length > 0">
                      <div class="upDocSelectLinksHead mt-1 font-weight-bold">Выберите договор:</div>
                      <div 
                          v-for="doc in filteredDocs" 
                          @click="changeSelectedDoc(doc)"
                          :key="doc.id"
                          class="docSelectLinks"
                      >
                          {{ doc.name }} ({{ doc.date_of_document | formattedDate }})
                      </div>
                    </template>  
                    <template v-if="editMode && filteredDocs.length == 0">
                      <div class="upDocSelectLinksHead mt-1 font-weight-bold">Добавьте в компанию <br />хотя бы один договор ТЭО!</div>
                    </template>
                  </b-col>
                  <b-col sm="6" md="2">
                    <label for="data_of_dogovor">Дата договора:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <b-form-input v-model="editedData['1'].value" type="date" size="sm" placeholder="" :disabled="true"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="name_of_cargo">Наименование груза, код ТНВЭД:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['name_of_cargo']" name="name_of_cargo" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="import_export">Импорт / Экспорт:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-select 
                      v-model="editedData['import_export']" 
                      name="import_export" 
                      size="sm" 
                      placeholder="" 
                      :options="[
                        { value: 'Импорт', text: 'Импорт' },
                        { value: 'Экспорт', text: 'Экспорт' }
                      ]"
                      :disabled="!localEditMode"
                    ></b-form-select>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col sm="12" md="6">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="number_of_places">Кол-во мест:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['number_of_places']" type="number" name="number_of_places" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="weight">Вес, кг.:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['weight']" type="number" name="weight" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="volume">Объем, м<sup>3</sup>:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['volume']" type="number" name="volume" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
          <hr>
          <b-container fluid class="mt-3">
            <b-row class="my-2 mb-3">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="cargo_sender_name">Грузоотправитель:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['cargo_sender_name']" name="cargo_sender_name" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="address_g_o">Адрес ГО:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['address_g_o']" name="address_g_o" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="mesto_pogruzki_oblast">Прием груза:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-row class="my-2">
                      <b-col sm="6">
                        <b-form-input v-model="editedData['mesto_pogruzki_oblast']" name="mesto_pogruzki_oblast" size="sm" placeholder="Введите область" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                      <b-col sm="6">
                        <b-form-input v-model="editedData['mesto_pogruzki_gorod']" name="mesto_pogruzki_gorod" size="sm" placeholder="Введите город" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="my-2">
                      <b-col sm="12">
                        <b-form-input v-model="editedData['mesto_pogruzki_street']" name="mesto_pogruzki_street" size="sm" placeholder="Введите улицу" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="contact_name_on_shipment">Контактное лицо на погрузке, телефон:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['contact_name_on_shipment']" name="contact_name_on_shipment" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="my-2 mb-3">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="cargo_recipient_company_id">Грузополучатель:</label>
                  </b-col>
                  <b-col sm="10">
                    <tsoft-select-company
                      :needNullElement="true"
                      :selected="editedData['cargo_recipient_company_id']"
                      :disabled="!localEditMode"
                      @set="setCompanyRecipientOfOrder"
                    ></tsoft-select-company>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="inn_g_p">ИНН/КПП:</label>
                  </b-col>
                  <b-col sm="5">
                    <b-form-input v-model="editedData['inn_g_p']" name="inn_g_p" size="sm" placeholder="Введите ИНН" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="5">
                    <b-form-input v-model="editedData['kpp_g_p']" name="kpp_g_p" size="sm" placeholder="Введите КПП" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="address_g_p">Адрес ГП:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['address_g_p']" name="address_g_p" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="address_of_unloading_oblast">Сдача груза:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-row class="my-2">
                      <b-col sm="6">
                        <b-form-input v-model="editedData['address_of_unloading_oblast']" name="address_of_unloading_oblast" size="sm" placeholder="Введите область" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                      <b-col sm="6">
                        <b-form-input v-model="editedData['address_of_unloading_town']" name="address_of_unloading_town" size="sm" placeholder="Введите город" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="my-2">
                      <b-col sm="12">
                        <b-form-input v-model="editedData['address_of_unloading_street']" name="address_of_unloading_street" size="sm" placeholder="Введите улицу" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>                  
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="contact_name_on_unloading">Контактное лицо на разгрузке, телефон:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['contact_name_on_unloading']" name="contact_name_on_unloading" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
          <hr>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="2">
                <label for="perevozchik_id">Перевозчик:</label>
              </b-col>
              <b-col sm="10">
                <tsoft-select-company
                  :needNullElement="true"
                  :selected="editedData['perevozchik_id']"
                  :disabled="!localEditMode"
                  :additionalGetParams="`&is_transport_company=1&checked_id=444`"
                  @set="setCompanyPerevozchikOfOrder"
                ></tsoft-select-company>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col sm="12" md="4">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="perevozchik_name">Перевозчик. Наименование:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input 
                        v-model="editedData['perevozchik_name']" 
                        name="perevozchik_name" 
                        size="sm" 
                        placeholder="" 
                        :disabled="true"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="perevozchik_inn">Перевозчик. ИНН:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input 
                        v-model="editedData['perevozchik_inn']" 
                        name="perevozchik_inn" 
                        size="sm" 
                        placeholder="" 
                        :disabled="true"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="perevozchik_uridicheskiy_address">Перевозчик. Юр. адрес:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input 
                        v-model="editedData['perevozchik_uridicheskiy_address']"
                        name="perevozchik_uridicheskiy_address" 
                        size="sm" 
                        placeholder="" 
                        :disabled="true"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="nomer_of_tyagach">№ Тягача:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['nomer_of_tyagach']" name="nomer_of_tyagach" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="marka_of_tyagach">Марка тягача:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['marka_of_tyagach']" name="marka_of_tyagach" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="nomer_of_pricep">№ Прицепа:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['nomer_of_pricep']" name="nomer_of_pricep" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="marka_of_pricep">Марка прицепа:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['marka_of_pricep']" name="marka_of_pricep" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="voditel_fio">Водитель. ФИО:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['voditel_fio']" name="voditel_fio" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="voditel_passport">Водитель. Паспорт:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['voditel_passport']" name="voditel_passport" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="voditel_vu">Водитель. ВУ:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['voditel_vu']" name="voditel_vu" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>

      <div v-show="visible === 'etapy'">
        <b-card>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="name_of_cargo">Маршрут</label>
                  </b-col>
                  <b-col sm="10">
                    <b-list-group horizontal="md">
                      <b-list-group-item 
                        style="width: 50%"
                        :variant="variantByTwoDays(editedData['pogruzka_gruza_plan'], editedData['pogruzka_gruza_fact'])"
                      >
                        <template v-if="editedData.mesto_pogruzki_gorod && editedData.mesto_pogruzki_street">
                          <span class="small-description">адрес погрузки</span>
                          {{ editedData.mesto_pogruzki_gorod }}, {{ editedData.mesto_pogruzki_street }}
                        </template>
                        <template v-else>
                          {{ '<Укажите адрес погрузки>' }}
                        </template>
                        <br>
                        <small>{{ editedData['pogruzka_gruza_fact'] || editedData['pogruzka_gruza_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                      <b-list-group-item 
                        style="width: 50%"
                        :variant="variantByTwoDays(editedData['dostavka_plan'], editedData['dostavka_fact'])"
                      >
                        <template v-if="editedData.address_of_unloading_town && editedData.address_of_unloading_street">
                          <span class="small-description">адрес выгрузки</span>
                          {{ editedData.address_of_unloading_town }}, {{ editedData.address_of_unloading_street }}
                        </template>
                        <template v-else>
                          {{ '<Укажите адрес выгрузки>' }}
                        </template>
                        <br>
                        <small>{{ editedData['dostavka_fact'] || editedData['dostavka_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                    </b-list-group>                    
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <hr>
            <b-row class="my-2">
              <b-col sm="12" md="8">
                <b-row class="my-2">
                  <b-col sm="4">
                  </b-col>
                  <b-col sm="4" class="text-center">
                    План
                  </b-col>
                  <b-col sm="4" class="text-center">
                    Факт
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="pogruzka_gruza_plan">Дата погрузки:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['pogruzka_gruza_plan']" 
                        name="pogruzka_gruza_plan" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['pogruzka_gruza_fact']" 
                        name="pogruzka_gruza_fact" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col class="bg-gray-right">
                    <div class="details-group">
                        <div class="value-of-field">
                          <div class="table-document-correction">
                            <div class="text-uppercase">
                                <div>
                                    <i v-if="editedData['cargo_sender_name']" class="bx bx-check text-success mr-2"></i>
                                    <i v-if="!editedData['cargo_sender_name']" class="bx bx-x text-danger mr-2"></i>
                                    Грузоотправитель
                                </div>
                                <div>
                                    <i v-if="editedData['address_g_o']" class="bx bx-check text-success mr-2"></i>
                                    <i v-if="!editedData['address_g_o']" class="bx bx-x text-danger mr-2"></i>
                                    Адрес ГО
                                </div>
                                <div>
                                    <i v-if="editedData['contact_name_on_shipment']" class="bx bx-check text-success mr-2"></i>
                                    <i v-if="!editedData['contact_name_on_shipment']" class="bx bx-x text-danger mr-2"></i>
                                    Контактное лицо на погрузке
                                </div>
                                <div>
                                    <i v-if="editedData['inn_g_p']" class="bx bx-check text-success mr-2"></i>
                                    <i v-if="!editedData['inn_g_p']" class="bx bx-x text-danger mr-2"></i>
                                    Грузополучатель
                                </div>
                                <div>
                                    <i v-if="editedData['address_g_p']" class="bx bx-check text-success mr-2"></i>
                                    <i v-if="!editedData['address_g_p']" class="bx bx-x text-danger mr-2"></i>
                                    Адрес ГП
                                </div>
                                <div>
                                    <i v-if="editedData['address_of_unloading_oblast'] && editedData['address_of_unloading_town'] && editedData['address_of_unloading_street']" class="bx bx-check text-success mr-2"></i>
                                    <i v-if="!editedData['address_of_unloading_oblast'] || !editedData['address_of_unloading_town'] || !editedData['address_of_unloading_street']" class="bx bx-x text-danger mr-2"></i>
                                    Адрес разгрузки
                                </div>
                                <div>
                                    <i v-if="editedData['contact_name_on_unloading']" class="bx bx-check text-success mr-2"></i>
                                    <i v-if="!editedData['contact_name_on_unloading']" class="bx bx-x text-danger mr-2"></i>
                                    Контактное лицо на разгрузке
                                </div>
                                <div>
                                    <i v-if="editedData['perevozchik_name'] &&
                                             editedData['perevozchik_inn'] &&
                                             editedData['perevozchik_uridicheskiy_address']" class="bx bx-check text-success mr-2"></i>
                                    <i v-if="!editedData['perevozchik_name'] ||
                                             !editedData['perevozchik_inn'] ||
                                             !editedData['perevozchik_uridicheskiy_address']" class="bx bx-x text-danger mr-2"></i>
                                    Данные по перевозчику
                                </div>
                                <div>
                                    <i v-if="hasDocumentWithId339" class="bx bx-check text-success mr-2"></i>
                                    <i v-if="!hasDocumentWithId339" class="bx bx-x text-danger mr-2"></i>
                                    В документах «Заявка на перевозку»
                                </div>
                                <div>
                                    <i v-if="hasDocumentWithId353" class="bx bx-check text-success mr-2"></i>
                                    <i v-if="!hasDocumentWithId353" class="bx bx-x text-danger mr-2"></i>
                                    В документах «Страховой полис»
                                </div>
                            </div>
                          </div>
                        </div>
                        <div class="descr-of-field">Для проставления даты погрузки, заполните поля, добавьте документы.</div>
                    </div>
                </b-col>
            </b-row>

            <b-row class="my-2">
              <b-col sm="12" md="8">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="dostavka_plan">Дата выгрузки:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['dostavka_plan']" name="dostavka_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['dostavka_fact']" name="dostavka_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4" class="text-center"></b-col>
            </b-row>

            <hr>
            <b-row class="my-2">
              <b-col sm="12" class="text-center">
                <div class="bigNumber transitItogBlock">Общее транзитное время: {{ obshee_transitnoe_vremya }}</div>
              </b-col>
            </b-row>

          </b-container>
          
        </b-card>
      </div>

      <ActiveHistory
        v-if="visible === 'graph'"
        :serviceIds="detailedItem.id"
      />
    </b-overlay>
  </div>
</template>

<script>
import OrderServiceDeliveryQuotationInfo from '@/components/orders/orderServiceQuotation/OrderServiceDeliveryQuotationInfo.vue';
import ActiveHistory from '@/components/orders/orderServiceTemplate/v2/ActiveHistory';
import {
  constantsAllReferenceProperties,
  dateHelpers,
  dataHelpers
} from '@/mixins';

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    saveMode: {
      type: Boolean,
      default: false,
    },
    detailedItem: {
      type: Object,
      required: true,
    },
    filteredDocs: {
      type: Array,
      required: true,
    },
    zaprosInfo: {
      type: Boolean,
      default: true,
    },
    obshayaInfo: {
      type: Boolean,
      default: true,
    },
    etapyDvigeniya: {
      type: Boolean,
      default: true,
    },
    timelinePostavki: {
      type: Boolean,
      default: true,
    },
    defaultVisible: {
      type: String,
      default: 'obshaya',
    },
  },
  mixins: [
    constantsAllReferenceProperties,
    dateHelpers,
    dataHelpers
  ],
  components: {ActiveHistory, OrderServiceDeliveryQuotationInfo},
  data() {
    return {
      loading: false,
      localEditMode: false,
      visible: 'obshaya',
      editedData: {
        "0": { value: '' },
        "1": { value: '' },
        name_of_cargo: '',
        import_export: 'Импорт',
        number_of_places: 0,
        weight: 0,
        volume: 0,
        cargo_sender_name: '',
        address_g_o: '',
        mesto_pogruzki_oblast: '',
        mesto_pogruzki_gorod: '',
        mesto_pogruzki_street: '',        
        contact_name_on_shipment: '',
        cargo_recipient_company_id: null,
        inn_g_p: '',
        kpp_g_p: '',
        address_g_p: '',
        address_of_unloading_oblast: '',
        address_of_unloading_town: '',
        address_of_unloading_street: '',
        contact_name_on_unloading: '',

        perevozchik_id: null,
        perevozchik_name: '',
        perevozchik_inn: '',
        perevozchik_uridicheskiy_address: '',

        nomer_of_tyagach: '',
        nomer_of_pricep: '',
        marka_of_tyagach: '',
        marka_of_pricep: '',

        voditel_fio: '',
        voditel_passport: '',
        voditel_vu: '',

        pogruzka_gruza_plan: '',
        pogruzka_gruza_fact: '',

        dostavka_plan: '',
        dostavka_fact: '',
        obshee_transitnoe_vremya: ''
      },
    };
  },  
  computed: {
    obshee_transitnoe_vremya() {
      if (!this.editedData['pogruzka_gruza_fact'] || !this.editedData['dostavka_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['pogruzka_gruza_fact'], this.editedData['dostavka_fact']);
      return transitnoe_vremya == '0 дней' ? '1 день' : transitnoe_vremya;
    },
    hasDocumentWithId339() {
        const hasDocumentWithId339 = this.detailedItem.documents && 
            this.detailedItem.documents.some(document => document.reference_document_type_id === 339);

        return hasDocumentWithId339;
    },
    hasDocumentWithId353() {
        const hasDocumentWithId353 = this.detailedItem.documents && 
            this.detailedItem.documents.some(document => document.reference_document_type_id === 353);

        return hasDocumentWithId353;
    },
    isCanFillGotovnostGruza() {
        return true;
    }
  },
  watch: {
    editMode: {
      handler(value) {
        this.localEditMode = value;
      },
      immediate: true
    },
    saveMode: {
      handler(value) {
        if (value == true) {
          this.$emit('updateData', this.editedData);
        }
      },
      immediate: true
    },
    detailedItem: {
      handler(data) {
        this.editedData = this.deepMergeSafeFirst(JSON.parse(JSON.stringify(data.data)), JSON.parse(JSON.stringify(this.editedData)));
      },
      deep: true,
      immediate: true
    },
    obshee_transitnoe_vremya(value) {
      this.editedData['obshee_transitnoe_vremya'] = value;
    }
  },
  methods: {
    setReferenceValue(value, reference_id, index) {
      this.editedData[index] = value;
    },  
    setCompanyRecipientOfOrder(value, element) {
      this.editedData['cargo_recipient_company_id'] = value;
      this.editedData['inn_g_p'] = element.inn;
      this.editedData['kpp_g_p'] = element.kpp;
      this.editedData['address_g_p'] = element.address;
    },
    setCompanyPerevozchikOfOrder(value, element) {
      this.editedData['perevozchik_id'] = value;
      this.editedData['perevozchik_name'] = element.name;
      this.editedData['perevozchik_inn'] = element.inn;
      this.editedData['perevozchik_uridicheskiy_address'] = element.address;
    },
    changeSelectedDoc(doc) {
      this.editedData[0].value = doc.name;
      this.editedData[1].value = doc.date_of_document;
    },    
  },

  mounted() {
    this.visible = this.defaultVisible;
  },
};
</script>
<style scoped>
.custom-select {
  height: 34px !important;
  border-radius: 3px !important;
  padding: 1px 8px;
}
.small-description {
  line-height: 11px;
}

</style>